import React from 'react'
import './home.scss'

function Home() {
  return (
    <div>
      <h2>Welcome to the EZCorp WebComponents Test Center!</h2>
    </div>
  )
}

export default Home